import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { alpha, Box, Typography, useTheme } from '@mui/material';
import { FileUploader } from 'react-drag-drop-files';
import { Icon } from '@iconify/react';
const FileUploadDropzone = ({ onChange, label, types, value, uploadedFileName, icon = 'eva:cloud-upload-fill', iconColor, iconSize = 40, sx, contentSx, renderUploadedFileName, multiple = false, errorText }) => {
    const theme = useTheme();
    const hasError = Boolean(errorText);
    const wrapperSx = useMemo(() => {
        const additional = Array.isArray(sx) ? sx : sx ? [sx] : [];
        return [
            (theme) => {
                const borderColor = hasError
                    ? theme.palette.error.main
                    : alpha(theme.palette.grey[500], 0.2);
                const backgroundColor = hasError
                    ? alpha(theme.palette.error.main, 0.08)
                    : alpha(theme.palette.grey[500], 0.08);
                return {
                    alignSelf: 'stretch',
                    border: `1px dashed ${borderColor}`,
                    borderRadius: 1.5,
                    bgcolor: backgroundColor,
                    p: 2.5,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 0.5,
                    position: 'relative',
                    '& .IlZQX > input': {
                        display: 'block',
                        opacity: 0,
                        position: 'absolute',
                        pointerEvents: 'none',
                        top: 0,
                        left: 0,
                        right: 0
                    }
                };
            },
            ...additional
        ];
    }, [hasError, sx]);
    const innerContentSx = useMemo(() => {
        const additional = Array.isArray(contentSx) ? contentSx : contentSx ? [contentSx] : [];
        return [
            {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 0.5,
                cursor: 'pointer'
            },
            ...additional
        ];
    }, [contentSx]);
    const normalizedValue = Array.isArray(value) ? value : value ? [value] : [];
    const derivedFileName = uploadedFileName ?? (normalizedValue.length ? normalizedValue[0].name : undefined);
    const fileNameContent = derivedFileName &&
        (renderUploadedFileName?.(derivedFileName) ?? (_jsxs(Typography, { variant: 'body2', color: 'text.secondary', children: ["\uD83D\uDCCE ", derivedFileName] })));
    const handleUpload = (fileOrFiles) => {
        if (fileOrFiles instanceof FileList) {
            const filesArray = Array.from(fileOrFiles);
            onChange(multiple ? filesArray : (filesArray[0] ?? null));
            return;
        }
        onChange(multiple ? [fileOrFiles] : fileOrFiles);
    };
    return (_jsxs(Box, { sx: wrapperSx, children: [_jsx(FileUploader, { handleChange: handleUpload, types: types, multiple: multiple, children: _jsxs(Box, { sx: innerContentSx, children: [_jsx(Icon, { icon: icon, width: iconSize, height: iconSize, color: iconColor ?? theme.palette.grey[500] }), typeof label === 'string' ? (_jsx(Typography, { variant: 'body2', color: 'text.disabled', children: label })) : (label)] }) }), fileNameContent, hasError && (_jsx(Typography, { variant: 'caption', color: 'error', textAlign: 'center', children: errorText }))] }));
};
export default FileUploadDropzone;
